import React from 'react';
import { Box, Button, ButtonMode, Dialog } from 'edenred-ui';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { LeaveImportEmployeesModalProps } from '@epi-models/pages/Beneficiaries';

export const LeaveImportEmployeesModal = ({
  isOpen,
  onStay,
  onLeave
}: LeaveImportEmployeesModalProps) => {
  const { t } = useTranslation();
  const { sizeMedium, fontSemiBold, gray50, sizeExtraExtraLarge, gray85 } =
    useTheme();

  return (
    <Dialog
      open={isOpen}
      onClose={onStay}
      id="import-employees-leave-confirmation"
    >
      <Dialog.Content>
        <Box>
          <Box
            fontSize={sizeExtraExtraLarge}
            fontWeight={fontSemiBold}
            color={gray85}
          >
            {t(
              'containers.beneficiaries.import_employees.leave_confirmation.title'
            )}
          </Box>
          <Box fontSize={sizeMedium} color={gray50}>
            {t(
              'containers.beneficiaries.import_employees.leave_confirmation.body'
            )}
          </Box>
        </Box>
      </Dialog.Content>
      <Dialog.Actions>
        <Box display="flex" justifyContent="flex-end" gap={2}>
          <Button
            onClick={onStay}
            id="import-employees-leave-confirm-button"
            mode={ButtonMode.Secondary}
          >
            {t(
              'containers.beneficiaries.import_employees.leave_confirmation.stay'
            )}
          </Button>
          <Button onClick={onLeave} id="import-employees-leave-stay-button">
            {t(
              'containers.beneficiaries.import_employees.leave_confirmation.leave'
            )}
          </Button>
        </Box>
      </Dialog.Actions>
    </Dialog>
  );
};
